/**
 * Whether a failed follow is the plan's limit rather than a fault.
 *
 * The two codes come from musicapi: `FOLLOW_LIMIT_EXCEEDED` when the plan's
 * allowance is used up, `NO_FOLLOW_LIMIT` when the plan has no allowance at
 * all. `ErrorView` reads the same field for the full-screen version of this.
 */
export function isFollowLimitError(error: unknown): boolean {
  if (error === null || typeof error !== 'object' || !('data' in error)) {
    return false;
  }
  const { data } = error as { data: unknown };
  if (data === null || typeof data !== 'object' || !('errorType' in data)) {
    return false;
  }
  const { errorType } = data as { errorType: unknown };
  return errorType === 'FOLLOW_LIMIT_EXCEEDED' || errorType === 'NO_FOLLOW_LIMIT';
}
